export default {
  title: 'Koe paras käyttökokemus mobiilisovelluksessamme',
  description: 'Säästä aikaa, kerää palkintoja, saa ilmoituksia tarjouksista ja paljon muuta',
  buttons: {
    download: 'Avaa {{name}}-sovellus',
  },
};
